import { Link, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../services/authentication/authContext';
import { canAccessSupportPage, isInvoiceOnlyAccount } from '../services/accessManagement/accessManagement';
import { useImpersonationStore } from '../stores/appImpersonationStore';

export function SupportRoute({ children }: { children: JSX.Element }) {
  const { t } = useTranslation('support');
  const { user, backendUser, accountSettings, loading } = useAuth();
  const target = useImpersonationStore(state => state.target);
  const location = useLocation();
  if (loading) return <p className="p-6 text-tertiary dark:text-tertiary-dark" role="status">{t('access.loading')}</p>;
  if (!user) return <Navigate to="/login" state={{ supportReturnTo: location.pathname + location.search }} replace />;
  if (!backendUser || backendUser.id !== (target?.userId ?? user.id)) {
    return <p className="p-6 text-tertiary dark:text-tertiary-dark" role="status">{t('access.loading')}</p>;
  }
  if (!canAccessSupportPage(backendUser)) {
    return <div className="p-6 text-tertiary dark:text-tertiary-dark">
      <p role="alert">{t('access.denied')}</p>
      <Link className="mt-3 inline-block underline" to={isInvoiceOnlyAccount(backendUser, accountSettings) ? '/home' : '/dashboard'}>{t('access.back')}</Link>
    </div>;
  }
  return children;
}
